import React from 'react';

import style from '../orders/ordersStyle.module.css';


interface OrdersHeaderProps {
  type: string;
  orderNumber: string;
  forwarder: { org: string, orgAddress: string }
};

const ordersHeader = (props: OrdersHeaderProps) => {

  const title: string = props.type === 'po' ? 'Pick Up Order:' : 'Drop Off Order:';
  
  return (
    <div className={ [style.flex, style.headerWrapper].join(' ') }>

      <div className={ style.titleWrapper }>
        <span className={ style.orderTitle }>{ title }</span>
        <span className={ style.orderNumber }>{ props.orderNumber }</span>
      </div>

      <div className={ [style.headerWrapper, style.headerCompanyInfo].join(' ') }>
        <div className={ style.orgName }>{ props.forwarder.org }</div>
        <div>{ props.forwarder.orgAddress }</div>
      </div>
      
    </div>
       
  );
}

export default ordersHeader;